import React, { useEffect, useState, useContext } from "react"
import { Button, Col, FormGroup, Input, Label, Row, Spinner } from "reactstrap"
import createIntent from "../../common/config/createIntent"
import apiHandler from "../../common/config/apiHandler"
import AmendBooking from "../../common/config/amend-booking"
import toast from "react-hot-toast"
import EditCustomerDetails from "./editCustomerDetails"
// import EditTravelVehicle from "./editTravelVehicleDetails"
import StripeElement from "../../components/Stripe/StripeElement"
import domainUrl from "../../common/config/domainUrl"
import { DataContext } from "../../context/dataContext"

const EditCustomerTravelDetails = ({
  public_key,
  bookingDetails,
  toggleEditModal,
  handleCombinedChange,
  combinedData,
  setCombinedData,
  activeTab,
  setActiveTab,
  handleFetchBookingDetails,
}) => {
  const [extraCharges, setExtraCharges] = useState(0)
  const [clientSecret, setClientSecret] = useState("")
  const [loadingPayment, setLoadingPayment] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [paymentOption, setPaymentOption] = useState("")
  const [payment_intent, setPayment_Intent] = useState("")
  const [apiTag, setApiTag] = useState(null)
  const [transactionID, setTransactionID] = useState("")
  const { fetchSubscribeKey, subscribeKey } = useContext(DataContext)
  const [withAmount, setWithAmount] = useState(false)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
  })

  useEffect(() => {
    if (bookingDetails) {
      fetchSubscribeKey(apiTag, bookingDetails?.site_id)
    }
  }, [bookingDetails])

  useEffect(() => {
    if (paymentOption == "stripe-dashboard") {
      const currentDetail = bookingDetails?.bookingDetails?.find(
        detail => detail?.is_current === true || detail?.is_current === 1
      )

      setFormData({
        firstName: currentDetail?.customer?.first_name,
        lastName: currentDetail?.customer?.last_name,
      })
      setTransactionID(currentDetail?.payment?.transaction_id)
    }
  }, [paymentOption])

  const handleCreateIntent = async () => {
    if (!subscribeKey) return

    setLoadingPayment(true)
    // const amountInCents = Math.round(extraCharges * 100 || 0)

    try {
      const paymentIntentResponse = await createIntent({
        key: subscribeKey,
        amount: extraCharges,
        description: bookingDetails?.multi_mode,
      })

      if (paymentIntentResponse?.client_secret) {
        setClientSecret(paymentIntentResponse.client_secret)
        setPayment_Intent(paymentIntentResponse.payment_intent)
      } else {
        alert("Failed to create payment intent. Please try again.")
      }
    } catch (error) {
      console.error("Payment error:", error)
      alert(
        "Error creating payment intent. Please try again. Error: " +
          error.message
      )
    } finally {
      setLoadingPayment(false)
    }
  }

  const handleSubmit = async transaction_id => {
    setLoadingPayment(true)
    const user = JSON.parse(localStorage.getItem("user"))
    const currentDetail = bookingDetails?.bookingDetails?.find(
      detail => detail?.is_current === true || detail?.is_current === 1
    )
    const transactionId = currentDetail?.payment?.transaction_id

    const updatedCombinedData = {
      ...combinedData,
      key: subscribeKey,
      user_id: String(user?.id),
      extar_amount: withAmount ? extraCharges : 0,
      payment_type: withAmount ? paymentOption : "stripe-dashboard",
      transaction_id: transaction_id ? transaction_id : transactionId,
      company_email: combinedData?.company_email == true ? "1" : "0",
      customer_email: combinedData?.customer_email == true ? "1" : "0",
    }

    const amendResponse = await AmendBooking(updatedCombinedData)
    if (amendResponse?.response_code === 200) {
      toast.success(amendResponse?.data)
      handleFetchBookingDetails(bookingDetails?.id)
      setActiveTab("")
    } else {
      setLoadingPayment(false)
      setSubmitLoading(false)
      alert("Failed to amend booking. Please try again.")
    }
    setLoadingPayment(false)
    setSubmitLoading(false)
  }

  const handleWorldPay = async () => {
    const user = JSON.parse(localStorage.getItem("user"))
    setLoadingPayment(true)

    try {
      const response = await apiHandler({
        endpoint: "/backend/payment/create-worldpay-session",
        method: "POST",
        options: {
          "x-access-token": localStorage.getItem("token"),
        },
        data: {
          type: "editbooking",
          key: subscribeKey,
          amount: extraCharges,
          extra_amount: extraCharges ? extraCharges : 0,
          arrival_flight_no: combinedData?.arrival_flight_no,
          arrival_terminal: combinedData?.arrival_terminal,
          arrival_time: combinedData?.arrival_time,
          color: combinedData?.color,
          company_email: combinedData?.company_email,
          customer_email: combinedData?.customer_email,
          departure_flight_no: combinedData?.departure_flight_no,
          departure_terminal: combinedData?.departure_terminal,
          departure_time: combinedData?.departure_time,
          make: combinedData?.make,
          model: combinedData?.model,
          no_of_peoples: combinedData?.no_of_peoples,
          reg_no: combinedData?.reg_no,
          title: combinedData?.title,
          site_id: combinedData?.site_id,
          reference_no: combinedData?.reference_no,
          payment_type: paymentOption,
          user_id: String(user?.id),
          name: `${combinedData?.first_name} ${combinedData?.last_name}`,
          email: combinedData?.email,
          contact_no: combinedData?.contact_no,
          notify: `${domainUrl}/worldpay-notify?reference_no=${combinedData?.reference_no}`,
          response: `${domainUrl}/worldpay-response?reference_no=${combinedData?.reference_no}`,
          cancel: `${domainUrl}/worldpay-cancel?reference_no=${combinedData?.reference_no}`,
        },
      })
      if (response) {
        if (typeof window !== "undefined") {
          window.location.href = response?.data?.redirectUrl
          // console.log("host--------------", domainUrl);
        }
      }
    } catch (error) {
      setLoadingPayment(false)
      toast.error(error.response?.data?.message, { duration: 3000 })
    }
  }

  useEffect(() => {
    const currentDetail = bookingDetails?.bookingDetails?.find(
      detail => detail?.is_current === true || detail?.is_current === 1
    )

    setFormData({
      firstName: currentDetail?.customer?.first_name,
      lastName: currentDetail?.customer?.last_name,
    })
  }, [])

  return (
    <div>
      {activeTab === "editCustomer" && (
        <EditCustomerDetails
          bookingDetails={bookingDetails}
          toggleEditCustomerModal={toggleEditModal}
          handleCombinedChange={handleCombinedChange}
          setCombinedData={setCombinedData}
          combinedData={combinedData}
          setExtraCharges={setExtraCharges}
          setApiTag={setApiTag}
          setActiveTab={setActiveTab}
        />
      )}

      <Col md={6}>
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              className="border-primary"
              name="withAmount"
              checked={withAmount}
              onClick={() => setWithAmount(!withAmount)}
              style={{ fontSize: "11px" }}
            />{" "}
            With Amount
          </Label>
        </FormGroup>
      </Col>
      {withAmount && (
        <Row>
          <Col>
            <FormGroup>
              <label for="extraCharges">Amend Charges*</label>
              <Input
                type="text"
                name="extraCharges"
                id="extraCharges"
                value={Number(extraCharges).toFixed(2)}
                onChange={e => setExtraCharges(Number(e.target.value))}
                className="border-secondary"
              />
            </FormGroup>
          </Col>
          <StripeElement
            public_key={public_key}
            paymentOption={paymentOption}
            setPaymentOption={setPaymentOption}
            payment_intent={payment_intent}
            clientSecret={clientSecret}
            handleCreateIntent={handleCreateIntent}
            transactionID={transactionID}
            setTransactionID={setTransactionID}
            setLoadingPayment={setLoadingPayment}
            submitLoading={submitLoading}
            extraCharges={extraCharges}
            setSubmitLoading={setSubmitLoading}
            handleComplete={handleSubmit}
            apiTag={bookingDetails?.bookingDetails[0]?.company?.sku_tag}
            formData={formData}
          />
        </Row>
      )}

      <Button
        color="primary"
        onClick={() => {
          if (paymentOption == "worldpay") {
            handleWorldPay()
          } else {
            if (paymentOption == "" && withAmount) {
              toast.error("Please select a payment option", {
                duration: 3000,
              })
              return
            } else if (!withAmount) {
              handleSubmit()
            } else {
              setSubmitLoading(true)
            }
          }
        }}
        style={{ width: "150px" }}
        disabled={loadingPayment}
      >
        {loadingPayment ? (
          <Spinner size="sm" />
        ) : paymentOption == "worldpay" ? (
          "World Pay"
        ) : (
          "Save Changes"
        )}
      </Button>
    </div>
  )
}

export default EditCustomerTravelDetails
